import $ from 'jquery';

$.fn.dataTable.ext.buttons.clearFilters = {
	name: 'clearFilters',
	className: 'buttons-clear-filters',
	text: function (dt) {
		return dt.i18n('buttons.clearFilters', '<i class="fa fa-filter" />&nbsp;Clear&nbsp;filters');
	},
	init: function (dt) {
		const button = this;
		const filtered = anyFilterActive(dt);
		if(!filtered) {
			button.disable();
		}
		$(dt.table().node()).on('search.dt', function() {
			const filtered = anyFilterActive($(this).DataTable());
			if(filtered) {
				button.enable();
			} else {
				button.disable();
			}
		});
	},
	action: function (e, dt) {
		dt.clearFilters();
	}
};

function anyFilterActive(dt) {
	return dt.search() || dt.columns().search().filter(x => x).length > 0;
}


// WEBPACK FOOTER //
// ./node_modules/linksoft-datatables/src/buttons/clearFilters.js